//import CustomTable from '../../components/CustomTable'
import React, { useMemo, useState } from "react";

function Images() {
    // Определяем столбцы и данные
    const columns = useMemo(
      () => [
        {
          Header: "Имя",
          accessor: "name", // Ключ в данных
          Filter: "", // Фильтр для столбца
        },
        {
          Header: "Возраст",
          accessor: "age",
        },
        {
          Header: "Город",
          accessor: "city",
        },
      ],
      []
    );

    const data = useMemo(
      () => [
        { name: "Иван", age: 25, city: "Москва" },
        { name: "Петр", age: 30, city: "Санкт-Петербург" },
        { name: "Анна", age: 28, city: "Казань" },
        { name: "Мария", age: 22, city: "Екатеринбург" },
      ],
      []
    );

    return (
      <>
        <h1>Images</h1>
        <div>
          <h1 className="text-center mt-4">Таблица с фильтрацией и сортировкой</h1>
          {/* <CustomTable columns={columns} data={data} /> */}
        </div>
      </>
    )
  }
  
export default Images
